import { render, staticRenderFns } from "./Nametag.vue?vue&type=template&id=252b1eea&scoped=true&"
import script from "./Nametag.vue?vue&type=script&lang=ts&"
export * from "./Nametag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252b1eea",
  null
  
)

export default component.exports